/*
 * fn: sendMediavineIdentity
 *
 * Sends hashed email to MediaVine via the window object
 *
 */
import { MEDIAVINE_IDENTITY_EVENT } from '@/defs/ad'
import { encodeSha256 } from '@/utils/commonUtil'

export const sendMediavineIdentity = async (email: string) => {
  const emailHash = await encodeSha256(email.trim().toLowerCase()).catch(() => null)

  if (!emailHash) return

  const optIn = async () => {
    try {
      const web = window.$adManagementConfig?.web

      if (!web) return false

      await web.identityOptIn({ email: emailHash })
      return true
    } catch {
      return false
    }
  }

  if (await optIn()) return

  window.addEventListener(MEDIAVINE_IDENTITY_EVENT, () => optIn(), { once: true })
}
